var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.click}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fab fa-instagram")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }